import { ApolloProvider } from '@apollo/client'
import { CssBaseline } from '@material-ui/core'
import React, { ReactNode } from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { AlertContainer, LoaderContainer } from './components'
import './i18n'
import './index.css'

import {
  StylesProvider,
  ThemeProvider as ThemeProviderV4,
  createGenerateClassName,
} from '@material-ui/core'
import { ThemeProvider as ThemeProviderV7 } from '@mui/material/styles'
import { App } from './App'
import { apolloClient } from './apollo'
import { WalletProvider } from './resources/web3'
import * as serviceWorker from './serviceWorker'
import { WebApi, WebApiContext } from './services/web-api'
import { GlobalCssStyles, defaultThemeV4, defaultThemeV7 } from './theme/default'

const webApi = new WebApi()

interface ThemeProviderProps {
  children: ReactNode
  // any other props that come into the component
}

const generateClassName = createGenerateClassName({
  // By enabling this option, if you have non-MUI elements (for example `<div />`)
  // using MUI classes (for example `.MuiButton`) they will lose styles.
  // Make sure to convert them to use `styled()` or `<Box />` first.
  disableGlobal: true,
  // Class names will receive this seed to avoid name collisions.
  seed: 'mui-jss',
})

function AppV7ThemeProvider({ children }: ThemeProviderProps) {
  return (
    <StylesProvider generateClassName={generateClassName}>
      <ThemeProviderV4 theme={defaultThemeV4}>
        <ThemeProviderV7 theme={defaultThemeV7}>
          <CssBaseline />
          <GlobalCssStyles />
          {children}
        </ThemeProviderV7>
      </ThemeProviderV4>
    </StylesProvider>
  )
}

render(
  <React.StrictMode>
    <ToastContainer />
    <AppV7ThemeProvider>
      <ApolloProvider client={apolloClient}>
        <WebApiContext.Provider value={{ webApi }}>
          <BrowserRouter>
            <WalletProvider>
              <AlertContainer />
              <App />
              <LoaderContainer />
            </WalletProvider>
          </BrowserRouter>
        </WebApiContext.Provider>
      </ApolloProvider>
    </AppV7ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
